export const SinorPushScreenTypes = [
    {
        name: '메인',
        page: 'MainPage',
        params: {
            'params.index': {
                label: '탭 번호',
                type: 'string',
                description: '매인 : 0 (default),내 모임 : 1,스토리:2, 채팅 목록 : 3,내 정보 :4',
            },
        },
    },
    {
        name: '모임',
        page: 'gather',
        params: {
            'params.gathering_id': {
                label: '모임 ID',
                type: 'string',
            },
        },
    },
    {
        name: '게시글',
        page: 'schedule',
        params: {
            'params.contents_id': {
                label: '게시글 ID',
                type: 'string',
            },
        },
    },
    {
        name: '웹뷰 페이지',
        page: 'EventPage',
        params: {
            'params.url': {
                label: 'URL',
                type: 'string',
            },
            'params.title': {
                label: '상단 제목',
                type: 'string',
            },
        },
    },
    {
        name: '공동 구매 목록/상세 페이지',
        page: 'CommercePage',
        params: {
            'params.tabIdx': {
                label: '카테고리',
                type: 'string',
                description: '전체:0,여행:1,식품:2,리빙:3,가전/디지털:4,기타:5',
            },
            'params.initProductId': {
                label: '상품 상세 ID',
                type: 'string',
                description: '상세 ID값이 있으면 상세 페이지로 이동합니다',
            },
        },
    },
    {
        name: '외부 링크',
        params: {
            url_link: {
                label: 'URL',
                type: 'string',
            },
        },
    },
];

export const SirupPushScreenTypes = [
    {
        name: '메인',
        page: 'MainPage',
        params: {
            'params.index': {
                label: '탭 번호',
                type: 'string',
                description: '매인 : 0 (default),친구 : 1,채팅 : 2,내 정보 :3',
            },
        },
    },
    {
        name: '시놀 - 게시글',
        params: {
            url_link: {
                label: '게시글ID',
                type: 'string',
                preFix: 'https://web.sinor.co.kr/GatheringContentsDetailPage?contents_id=',
            },
        },
    },
    {
        name: '시놀 - 모임',
        params: {
            url_link: {
                label: '모임ID',
                type: 'string',
                preFix: 'https://web.sinor.co.kr/gather?gathering_id=',
            },
        },
    },
    {
        name: '웹뷰',
        page: 'EventPage',
        params: {
            'params.url': {
                label: 'URL',
                type: 'string',
            },
            'params.title': {
                label: '상단 제목',
                type: 'string',
            },
        },
    },
    {
        name: '공동 구매 목록/상세 페이지',
        page: 'CommercePage',
        params: {
            'params.initProductId': {
                label: '상품 상세 ID',
                type: 'string',
                description: '상세 ID값이 있으면 상세 페이지로 이동합니다',
            },
        },
    },
    {
        name: '외부 링크',
        params: {
            url_link: {
                label: 'URL',
                type: 'string',
            },
        },
    },
];
